import React from 'react';
import {locations, operators, headings, aircrafts, timezone} from '../../constants'
import _ from 'lodash'
import moment from 'moment-timezone'

export const formatInt = (i) => (i < 10 ? `0${i}` : `${i}`)

export const renderTextField = ({ input, label, type, disabled, ignoreTouched, placeholder, inputClass, meta: { touched, error } }) => {
    //console.log('renderTextField', label, touched, error, 'disabled:', disabled, 'ignoreTouched', ignoreTouched, 'value:', input.value, 'input', input)

    return (<div className="my-text-div">
            {label && <label className="my-text-label">{label}</label>}
            {disabled ? <div className="my-text-disabled">
                    {input.value}
                    {(ignoreTouched || touched) && error && <div className="text-error">{error}</div>}
                </div>: <div className="my-text-inner-div">
                    <input {...input} className={`${inputClass || ''} my-text-input`} style={{width: '100%'}} placeholder={placeholder} type={type}/>
                    {(ignoreTouched || touched) && error && <div className="text-error">{error}</div>}
                </div>
            }
        </div>
    )
}

export const renderTextArea = ({ input, label, type, disabled, ignoreTouched, placeholder, inputClass, meta: { touched, error } }) => {
    //console.log('renderTextArea', label, touched, error, 'disabled:', disabled, 'ignoreTouched', ignoreTouched, 'value:', input.value, 'input', input)

    return (<div className="my-text-div">
            {label && <label className="my-text-label">{label}</label>}
            {<div className="my-text-inner-div">
                <textarea {...input} className={`${inputClass || ''} my-text-input`} style={{width: '100%', height: '200px'}} placeholder={placeholder} type={type}/>
                {(ignoreTouched || touched) && error && <div className="text-error">{error}</div>}
            </div>
            }
        </div>
    )
}

export const renderErrorField = ({ ignoreTouched,  meta: { touched, error } }) => {
    return (<div>
            {(ignoreTouched || touched) && error && <div className="text-error">{error}</div>}
        </div>
    )
}

export const renderAircraftSelector = ({ input, label, meta: { touched, error } }) => (<div>
    <label>{label}</label>
    <select {...input} className="width100">
        <option value="">Select aircraft...</option>
        {_.keys(aircrafts).map(k => <option value={k} key={k}>{aircrafts[k]}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const renderOperatorSelector = ({ input, label, meta: { touched, error } }) => (<div>
    <label>{label}</label>
    <select {...input} className="width100">
        <option value="">Select operator...</option>
        {_.keys(operators).map(k => <option value={k} key={k}>{operators[k]}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)


export const renderHeadingSelector = ({ input, label, meta: { touched, error } }) => (<div>
    <label>{label}</label>
    <select {...input} className="width100">
        <option value="">Select heading...</option>
        {_.keys(headings).map(k => <option value={k} key={k}>{headings[k].name}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const renderLocationSelector = ({ input, label, meta: { touched, error } }) => (<div>
    <label>{label}</label>
    <select {...input} className="width100">
        <option value="">Select location...</option>
        {_.keys(locations).map(k => <option value={k} key={k}>{locations[k]}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const getDayWithOffsetFromToday = (offset) => {
    const m = moment().tz(timezone).add({days: offset})
    return {key: m.format('YYYY-MM-DD'), value: m.format('DD/MM')}
}

export const renderDaySelector = ({ input, label, wideDateRange, meta: { touched, error } }) => {

    const days = _.range(wideDateRange ? -7 : -2, wideDateRange ? 21 : 2).map(p => getDayWithOffsetFromToday(p))

    return (<div>
        <label>{label}</label>
        <select {...input} className="width100" value={input.value || getDayWithOffsetFromToday(0).key} >
            {days.map(d => <option value={d.key} key={d.key}>{d.value}</option>)}
        </select>
        {touched && error && <div className="text-error">{error}</div>}
    </div>)
}

export const minutes = _.range(60)
export const renderMinutesSelector = ({ input, label,  meta: { touched, error } }) => (<div>
    <label>{label}</label>
    <select {...input} className="width100">
        <option value="">Minutes</option>
        {minutes.map(val => <option value={formatInt(val)} key={formatInt(val)}>{formatInt(val)}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const seconds = _.range(60)
export const renderSecondsSelector = ({ input, label, meta: { touched, error } }) => (<div>
    <label>{label}</label>
    <select {...input} className="width100">
        <option value="">Seconds</option>
        {seconds.map(val => <option value={formatInt(val)} key={formatInt(val)}>{formatInt(val)}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const hours = _.range(24)
export const renderHoursSelector = ({ input, label, meta: { touched, error } }) => (<div>
    <label>{label}</label>
    <select {...input} className="width100">
        <option value="">Hours</option>
        {hours.map(val => <option value={formatInt(val)} key={formatInt(val)}>{formatInt(val)}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const secondsAsMinutes = _.range(121)
export const renderSecondsAsMinutesSelector = ({ input, label, firstEntry,  meta: { touched, error } }) => (<div>
    {/*console.log('renderSecondsAsMinutesSelector', input)*/}
    <label>{label}</label>
    <select {...input} className="width100">
        {firstEntry && <option value={undefined}>{firstEntry}</option>}
        {secondsAsMinutes.map(val => <option value={val*60} key={val}>{`${val}m`}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const formatMinsSecs = (val) => {
    return `${Math.floor(val / 60)}m ${formatInt(Math.round((val % 60)))}s`
}

export const secondsExtended = [..._.range(0, 5*60, 10), ..._.range(5*60,61*60,60)] //10s increments below 5 minutes
export const renderNumbersExtendedSelector = ({ input, label, firstEntry,  meta: { touched, error } }) => (<div>
    {/*console.log('renderNumbersExtendedSelector', label, input)*/}
    <label>{label}</label>
    <select {...input} className="width100">
        {firstEntry && <option value={undefined}>{firstEntry}</option>}
        {secondsExtended.map(val => {
            //console.log('vvv', val)
            return <option value={val} key={val}>{`${val < 5*60 ? formatMinsSecs(val) : `${Math.round(val / 60)}m`}`}</option>
        })}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)

export const renderOneToFour = ({ input, label, firstEntry,  meta: { touched, error } }) => (<div>
    {/*console.log('renderOneToFour', label, input)*/}
    <label>{label}</label>
    <select {...input} className="">
        {[1,2,3,4].map(val => <option value={val} key={val}>{`${val}`}</option>)}
    </select>
    {touched && error && <div className="text-error">{error}</div>}
</div>)


// WEBPACK FOOTER //
// ./src/components/common/RenderFields.jsx